(function () {
  /**
   * @ngdoc module
   * @name app.core.products.usage
   * @description Module which defines product usage-related models
   */
  angular.module('app.core.products.usage', [
    'binky.core.lodash',
    'binky.core.offers.fulfillable-items',
    'binky.core.product',
  ]);
})();
